import { GET_USER_DATA_FULFILLED } from 'store/app/auth/action';
import { SET_USER, TYPING } from 'store/app/entities/users/action';
import { parseMeResponse } from 'utils/mePayload';

const createUser = u => ({
  _id: u._id,
  firstName: u.firstName,
  surName: u.surName,
  phone: u.phone,
  role: u.role,
  lastSeen: u.lastSeen,
  createdAt: u.createdAt,
  isSuperAdmin: u.isSuperAdmin,
  isOnline: u.isOnline,
  isTyping: u.isTyping,
  isApp: u.isApp,
  loginType: u.loginType,
});

const usersReducer = (state = {}, { type, payload }) => {
  switch (type) {
    case SET_USER:
    case GET_USER_DATA_FULFILLED: {
      const users = { ...state };
      const { user: meUser } =
        type === GET_USER_DATA_FULFILLED ? parseMeResponse(payload) : { user: payload };
      const existing = users[meUser._id] || {};
      users[meUser._id] = createUser({
        ...existing,
        ...meUser,
        isSuperAdmin: meUser.role === 2 || existing.isSuperAdmin,
        isTyping: meUser.isTyping || existing.isTyping,
      });

      return users;
    }

    case TYPING: {
      const users = { ...state };
      const existing = users[payload.user._id] || {};
      const isTyping = { ...(existing.isTyping || {}), [payload.channel]: payload.status };
      users[payload.user._id] = createUser({
        ...existing,
        ...payload.user,
        isSuperAdmin: payload.user.role === 2 || existing.isSuperAdmin,
        isTyping,
      });
      return users;
    }

    default:
      return state;
  }
};

export default usersReducer;
